import { Component, OnInit, inject } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { TabComponent } from '../../../../shared/components/tabs/tab/tab.component';
import { TabsComponent } from '../../../../shared/components/tabs/tabs.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BasicTableComponent } from '../basic-table/basic-table.component';
import { BasicTablePipe } from '../basic-table/basic-table.pipe';
import { InfoCardComponent } from '../info-card/info-card.component';
import { InfoCardPipe } from '../info-card/info-card.pipe';

@Component({
  selector: 'app-client-monitor-dialog',
  standalone: true,
  imports: [InfoCardComponent, ButtonComponent, TabsComponent, TabComponent, InfoCardPipe, BasicTableComponent, BasicTablePipe],
  templateUrl: './client-monitor-dialog.component.html',
  styleUrl: './client-monitor-dialog.component.scss',
})
export class ClientMonitorDialogComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);

  accountInformation!: any;
  addresses: any[] = [];
  client!: any;

  ngOnInit() {
    this.accountInformation = {
      firstName: this.config.data.monitorData?.Account?.FirstName,
      lastName: this.config.data.monitorData?.Account?.LastName,
      phoneNumber: this.config.data.monitorData?.Account?.MobileNumber,
      email: this.config.data.monitorData?.Account?.Email,
      gender: this.config.data.monitorData?.Sex,
    };

    this.config.data.monitorData?.Locations?.forEach((l: any) => {
      this.addresses.push({
        nickname: l.Location?.FullAddress,
        Address: l.Name,
      });
    });

    if (this.config.data.monitorData?.ClientName) {
      this.client = {
        payingClient: this.config.data.monitorData?.ClientName,
      };
    }
  }
}
